import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import { Location } from '@angular/common';
import { PerfilRiesgoService } from '../../_services/perfil-riesgo.service';
import { PerfilRiesgoVariacionMontoService } from '../../_services/perfil-riesgo-variacion-monto.service';
import { PerfilRiesgoVariacionCicloService } from '../../_services/perfil-riesgo-variacion-ciclo.service';
import { CanalProducto } from '../../_models/canal-producto';
import { CanalRol } from '../../_models/canal-rol';
import { PerfilRiesgo } from '../../_models/perfil-riesgo';
import { PerfilRiesgoVariacionMonto } from '../../_models/perfil-riesgo-variacion-monto';
import { PerfilRiesgoVariacionCiclo } from '../../_models/perfil-riesgo-variacion-ciclo';
import { forkJoin } from 'rxjs';
import { AdjuntoService } from '../../_services/adjunto.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component( {
  selector: 'app-perfiles-riesgo-detalle',
  templateUrl: 'perfiles-riesgo-detalle.component.html'
} )

export class PerfilesRiesgoDetalleComponent implements OnInit {

  perfil: PerfilRiesgo;
  perRiesgoTasas: PerfilRiesgoVariacionMonto[] = [];
  perRiesgoCiclos: PerfilRiesgoVariacionCiclo[] = [];
  carInformacionInicial = true;
  colTasas: any[];
  colCiclos: any[];
  imagen: any;


  constructor( private perRiesgoServicio: PerfilRiesgoService,
               private route: ActivatedRoute,
               private perRiesgoTasasServicio: PerfilRiesgoVariacionMontoService,
               private perRiesgoCiclosServicio: PerfilRiesgoVariacionCicloService,
               private nav: NavService,
               private adjServicio: AdjuntoService,
               private location: Location ) {
  }

  ngOnInit(): void {
    this.colTasas = [
      { field: 'nombreModalidad', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_MODALIDAD' ), sort: false },
      { field: 'tasaModalidad', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_TASAEA' ), sort: false },
      { field: 'tasaPeriodica', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_TASAPERIODICA' ), sort: false },
      { field: 'puntosDisminucion', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_PUNTODISMINUCION' ), sort: false },
      { field: 'montoMinimo', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_MONTOMINIMO' ), sort: false },
      { field: 'montoMaximo', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_MONTOMAXIMO' ), sort: false },
    ];

    this.colCiclos = [
      { field: 'id', header: this.nav.buscarMensaje( 'LBL_ID' ), sort: false },
      { field: 'nombreModalidad', header: this.nav.buscarMensaje( 'PERFILRIESGOCICLO.LBL_MODALIDAD' ), sort: false },
      { field: 'ciclo', header: this.nav.buscarMensaje( 'PERFILRIESGOCICLO.LBL_CICLO' ), sort: false },
      { field: 'puntosDisminucion', header: this.nav.buscarMensaje( 'PERFILRIESGOCICLO.LBL_PUNTODISMINUCION' ), sort: false },
      { field: 'indicadorHabilitado', header: this.nav.buscarMensaje( 'LBL_HABILITADO' ), sort: false }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin(
        this.perRiesgoServicio.obtenerPorId( params[ 'id' ] ),
        this.perRiesgoTasasServicio.listadoPorPerfilRiesgo( params[ 'id' ] ),
        this.perRiesgoCiclosServicio.listadoPorPerfilRiesgo( params[ 'id' ] )
      ).subscribe( ( [ perfil, perTasas, perCiclos ] ) => {
        this.perfil = perfil;
        this.adjServicio.descargarArchivo(this.perfil.idAdjunto).subscribe( adjunto => {
          let reader = new FileReader();
          reader.addEventListener("load", () => {
            this.imagen = reader.result;
          }, false);
          if (adjunto) {
            reader.readAsDataURL( adjunto );
          }
        });
        this.perRiesgoTasas = perTasas.filter(x => x.indicadorHabilitado);
        this.perRiesgoCiclos = perCiclos;
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }

}
